import React, { Component } from "react";
import { Div, Text, Input, Button, Image } from "atomize";
import InnerHTML from "../../utilities/innerHtml";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import ImageLink from "../common/ImageLink";
import { IsValidUrl, updateActiveCampaignForm } from "../../utilities/helpers";
import SolutionsPagesButton from "../common/SolutionsPagesButtons";

export default class BuzzLaunch extends Component {
  render() {
    const { content, form } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer p={{ x: { xs: "0", md: "2.5rem" } }}>
          <Div
            m={{ t: { xs: "11rem", md: "13rem" } }}
            d="flex"
            flexDir={{ xs: "column", md: "row" }}
            bg="primary"
            p={{
              x: { xs: "1.5rem", md: "2.8rem" },
              y: { xs: "3.75rem", md: "3.4rem" },
            }}
          >
            <Div d="flex" flexDir="column" justify="space-between" flexGrow="1">
              <Text
                textSize={{ xs: "title2", md: "subheader3" }}
                textWeight="bold"
                tag="h2"
                textColor="black"
              >
                {content.heading}
              </Text>
              <Div
                d={{ xs: "block", md: "none" }}
                m={{ t: "2.625rem", b: "3.625rem" }}
              >
                <ImageLink link={content.imgLink}>
                  <Div
                    bgImg={content.image}
                    bgSize="cover"
                    p={{ b: "57.5%" }}
                  ></Div>
                </ImageLink>
              </Div>

              <Div>
                <SolutionsPagesButton bgColor="black" textColor="white" />
                {/* <Text
                  m={{ b: ".8rem" }}
                  fontFamily="secondary"
                  textWeight="bold"
                  textColor="black"
                >
                  {content.text1}
                </Text>
                {typeof window !== "undefined" && (
                  <InnerHTML html={updateActiveCampaignForm(form)} />
                )} */}
              </Div>
            </Div>
            <Div
              m={{ xs: "0", md: "auto" }}
              flexGrow="1"
              p={{ l: { md: "3rem", lg: "6.25rem" } }}
              d={{ xs: "none", md: "block" }}
            >
              <ImageLink link={content.imgLink}>
                <Div
                  bgImg={content.image}
                  bgSize="cover"
                  p={{ b: "57.5%" }}
                ></Div>
              </ImageLink>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
